import React from "react";

import { Colors } from '_styles';

// used for displaying table values in booking list and review list
const PRMBio = (props) => {
    return (
        <div style={{ height: 60, textOverflow: 'ellipsis', overflow: 'auto', margin: 0, padding: 0, width: 200, marginLeft: -8, marginTop: 10 }}>
            <p style={{ fontSize: 14, opacity: 0.7, fontWeight: '300', textAlign: 'left', marginTop: 0 }}>{props.title.bio}</p>
            {
                props.title.equipmentInformation != undefined && props.title.equipmentInformation['battery'] != undefined ?
                    <div>
                        <p style={{ opacity: 0.6, fontWeight: 'bold', color: Colors.TEXT_COLOR }}>Equipment Information</p>
                        {<p style={{ opacity: 0.6, fontWeight: '200', marginTop: -10, color: Colors.TEXT_COLOR }}>- {props.title.equipmentInformation['battery'].value}</p>}
                        {props.title.equipmentInformation['make'] == null ? null : <p style={{ opacity: 0.6, fontWeight: '200', marginTop: -10, color: Colors.TEXT_COLOR }}>- {props.title.equipmentInformation['make']}</p>}
                        {props.title.equipmentInformation['model'] == null ? null : <p style={{ opacity: 0.6, fontWeight: '200', marginTop: -10, color: Colors.TEXT_COLOR }}>- {props.title.equipmentInformation['model']}</p>}
                        {props.title.equipmentInformation['weight'] == null ? null : <p style={{ opacity: 0.6, fontWeight: '200', marginTop: -10, color: Colors.TEXT_COLOR }}>- {props.title.equipmentInformation['weight']}kg</p>}
                        {props.title.equipmentInformation['dimensions']['height'] == null ? null : <p style={{ opacity: 0.6, fontWeight: '200', marginTop: -10, color: Colors.TEXT_COLOR }}>- {props.title.equipmentInformation['dimensions']['height']}cm x {props.title.equipmentInformation['dimensions']['width']}cm</p>}
                    </div>
                    :
                    ''
            }
        </div>
    )
}


export default PRMBio;